import {
  DndContext,
  MouseSensor,
  pointerWithin,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { FC, PropsWithChildren } from "react";

import { useStationRoutesDragHandling } from "@ryde/redux";

export const StationRoutesDragContextWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const { handleDragStart, handleDragEnd, handleDragOver, handleDragCancel } =
    useStationRoutesDragHandling();

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
  );
  return (
    <DndContext
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      sensors={sensors}
      collisionDetection={pointerWithin}
    >
      {children}
    </DndContext>
  );
};
